const lbaTextInput = angular.module('app.lbaTextInput', []);

lbaTextInput.controller('lbaTextInputCtrl', require('./lbaTextInputCtrl'));
lbaTextInput.directive('lbaTextInput', require('./lbaTextInputDir'));

export default lbaTextInput;



// WEBPACK FOOTER //
// ./src/components/lbaTextInput/index.js